module.exports = __webpack_public_path__ + "img/notion_black.98cdad80.png";